<!-- <tt-page class="col-xs-12 sp-0">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-6 p-5">
            <tt-textarea class="col-xs-12 sp-0" tt-label="custactinfotext" tt-model="vm.model.menu.custactinfotext" tt-change="vm.model.menu.custactinfotext = $value" tt-readonly="true"></tt-textarea>
        </tt-card>

        <tt-card class="col-xs-12 col-md-6 p-5">
            <div ng-show="vm.model.bgCustactCalcOrderSelection.selected === 'SUBTASKS' && vm.model.bgPostView.selected === 'POST'">
                <tt-button class="col-xs-12 sp-0" tt-text="categorydataselect" tt-click="vm.goToFunc('categorydataselect')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
                <tt-button class="col-xs-12 sp-0" tt-text="custactcalc_create_new_subtask" tt-click="vm.goToFunc('custactedit')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
            </div>

            <div ng-show="vm.model.menu.po_keyno > 0 && vm.model.menu.nbr_of_parents === '0'">
                <tt-button class="col-xs-12 sp-0" tt-text="custactcalc_update_po" tt-click="vm.updateCustactCalcPo()" tt-spin="vm.model.updatingCustactCalcPo" tt-text-align="center" tt-type="primary" tt-icon="fas fa-sync-alt" tt-icon-align="center"></tt-button>
            </div>

            <div ng-show="vm.model.menu.orderline_keyno === '0'">
                <tt-button ng-show="vm.model.menu.order_internal_no > 0" class="col-xs-12 sp-0" tt-text="custactcalc_transfer_to_order" tt-locked="vm.model.lockedCreateFromCustomer" tt-click="vm.createFromCustomer()" tt-text-align="center" tt-type="primary" tt-icon="fa fa-solid fa-plus" tt-icon-align="center"></tt-button>
                <tt-button ng-show="vm.model.menu.order_internal_no === '0'" class="col-xs-12 sp-0" tt-text="custactcalc_create_order" tt-locked="vm.model.lockedCreateFromCustomer" tt-click="vm.createFromCustomer()" tt-text-align="center" tt-type="primary" tt-icon="fa fa-solid fa-plus" tt-icon-align="center"></tt-button>
            </div>

            <tt-button-goto ng-show="vm.model.bgCustactCalcOrderSelection.selected === 'O'" class="col-xs-12 sp-0" tt-text="custactcalc_postcalc" tt-goto="postcalc" tt-goto-parms="{ argtype: 'custact_no', argvalue: vm.model.menu.custact_no }" tt-text-align="left"></tt-button-goto>
        </tt-card>
    </div>

    <tt-card class="col-xs-12 col-md-6 p-5">
        <tt-buttons-radio class="col-xs-12 sp-0" tt-buttons="vm.model.bgCustactCalcOrderSelection.buttons" tt-model="vm.model.bgCustactCalcOrderSelection.selected" tt-change="vm.selectBgCustactCalcOrderSelection($value)"></tt-buttons-radio>

        <div ng-show="vm.model.bgCustactCalcOrderSelection.selected === 'SUBTASKS'">
            <tt-buttons-radio class="col-xs-12 sp-0" tt-buttons="vm.model.bgOptionView.buttons" tt-model="vm.model.bgOptionView.selected" tt-change="vm.selectBgOptionView($value)"></tt-buttons-radio>
            <tt-buttons-radio class="col-xs-12 sp-0" tt-buttons="vm.model.bgPostView.buttons" tt-model="vm.model.bgPostView.selected" tt-change="vm.selectBgPostView($value)"></tt-buttons-radio>
        </div>
    </tt-card>

    <tt-grid ng-show="vm.model.bgCustactCalcOrderSelection.selected === 'SUBTASKS' && vm.model.bgPostView.selected === 'POST'" class="col-xs-12 p-5" tt-options="vm.grid" ng-if="vm.model.gridReady"></tt-grid>

    <tt-card class="col-xs-12 col-md-6 p-5" ng-show="vm.model.bgPostView.selected === 'TEXT'">
        <div ng-repeat="item in vm.model.inputListSubTaskTexts">
            <label ng-if="item.heading > ''" class="checklist-h1 col-xs-12" tt-header="{{item.heading}}"></label>
            <tt-textarea class="col-xs-12 sp-0" tt-label="text_sales" tt-model="item.text_sales" tt-change="item.text_sales = $value" tt-readonly="false"></tt-textarea>
            <tt-textarea class="col-xs-12 sp-0" tt-label="text_production" tt-model="item.text_production" tt-change="item.text_production = $value" tt-readonly="false"></tt-textarea>
            <tt-input-number class="col-xs-12 sp-0" tt-label="sortorderno" tt-model="item.sortorderno" tt-change="item.sortorderno = $value" tt-placeholder="" tt-style="" tt-text-align="right" tt-options="{ decimals: 0 }" tt-readonly="false"></tt-input-number>
            <tt-input class="col-xs-12 sp-0" tt-label="drawing_no" tt-model="item.drawing_no" tt-change="item.drawing_no = $value" tt-placeholder=""></tt-input>
        </div>

        <tt-button-save class="col-xs-12 sp-0" tt-text="save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>

    <tt-card class="col-xs-12 col-md-6 p-5" ng-show="vm.model.bgCustactCalcOrderSelection.selected === 'O'">
        <tt-input-buttons ng-show="vm.model.menu.order_internal_no > 0" class="col-xs-12 sp-0" tt-label="order_name" tt-model="vm.model.menu.order_name" tt-change="vm.model.menu.order_name = $value" tt-placeholder="" tt-buttons="vm.model.orderNameButtons" tt-readonly="true"></tt-input-buttons>
        <tt-input class="col-xs-12 sp-0" tt-label="cust_no" tt-model="vm.model.menu.cust_no" tt-change="vm.model.menu.cust_no = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="cust_name" tt-model="vm.model.menu.cust_name" tt-change="vm.model.menu.cust_name = $value" tt-readonly="true"></tt-input>
        <tt-input ng-show="vm.model.menu.orderline_keyno > 0" class="col-xs-12 sp-0" tt-label="orderline_keyno" tt-model="vm.model.menu.orderline_keyno" tt-change="vm.model.menu.orderline_keyno = $value" tt-readonly="true"></tt-input>
        <tt-input ng-show="vm.model.menu.po_keyno > 0" class="col-xs-12 sp-0" tt-label="po_keyno" tt-model="vm.model.menu.po_keyno" tt-change="vm.model.menu.po_keyno = $value" tt-readonly="true"></tt-input>
    </tt-card>

    <tt-card class="col-xs-12 col-md-12 p-5" ng-if="vm.model.menu.show_setting === '1'">
        <tt-button-settings class="col-xs-12 sp-0" tt-locked=""></tt-button-settings>
    </tt-card>
</tt-page> -->
<tt-page *ngIf="!!get">
    <div class="height-full flex-column">
        <tt-page-heading *ngIf="!!get.custactinfotext">Jobbkalkyle - {{ get.custactinfotext }}</tt-page-heading>
        <div>
            <!-- <tt-card class="col-xs-12 col-md-6 p-5"> -->
            <div class="col-xs-12 col-md-6 p-5" style="max-width: 60rem">
                <tt-tabs [(ttSelectedId)]="selectedCustactCalcOrderTab">
                    <tt-tab ttId="SUBTASKS" ttLabel="custactcalc_subtasks"></tt-tab>
                    <tt-tab ttId="0" ttLabel="custactcalc_order"></tt-tab>
                </tt-tabs>

                <div [hidden]="selectedCustactCalcOrderTab !== 'SUBTASKS'">
                    <tt-tabs [(ttSelectedId)]="get.optiontype" (ttSelectedIdChange)="onOptionTypeChanged()">
                        <tt-tab ttId="INCLUDED" ttLabel="custactcalc_included"></tt-tab>
                        <tt-tab ttId="OPTIONS" ttLabel="custactcalc_options"></tt-tab>
                    </tt-tabs>
                    <tt-tabs [(ttSelectedId)]="selectedPostTab">
                        <tt-tab ttId="POST" ttLabel="custactcalc_summary"></tt-tab>
                        <tt-tab ttId="TEXT" ttLabel="custactcalc_text"></tt-tab>
                    </tt-tabs>
                </div>
                <!-- </tt-card> -->
            </div>
            <tt-card class="col-xs-12 col-md-6 p-5" style="max-width: 60rem">
                <div [hidden]="!(selectedCustactCalcOrderTab === 'SUBTASKS' && selectedPostTab === 'POST')">
                    <tt-button-goto ttText="categorydataselect" ttGoto="categorydataselect" [ttGotoParms]="{ argtype: 'custact', argvalue: get.custact_no }" ttIcon="far fa-plus"></tt-button-goto>
                    <tt-button-goto
                        ttText="custactcalc_create_new_subtask"
                        ttGoto="custactedit"
                        [ttGotoParms]="{ custact_no: '0', filterfield: 'custact_no', filtervalue: get.custact_no }"
                        ttIcon="far fa-plus"
                    ></tt-button-goto>
                </div>
                <tt-button
                    [hidden]="!(get.po_keyno > '0' && get.nbr_of_parents === '0')"
                    ttText="custactcalc_update_po"
                    (ttClick)="updateCustactCalcPo()"
                    [ttLoading]="updatingCustactCalcPo"
                    ttIcon="fas fa-sync-alt"
                ></tt-button>
                <tt-button
                    class="col-xs-12 col-md-8 sp-5"
                    [hidden]="get.orderline_keyno !== '0'"
                    [ttText]="get.order_internal_no > '0' ? 'custactcalc_transfer_to_order' : 'custactcalc_create_order'"
                    (ttClick)="createFromCustomer()"
                    [ttLoading]="creatingFromCustomer"
                    ttIcon="fas fa-plus"
                ></tt-button>
                <tt-button-goto
                    [hidden]="selectedCustactCalcOrderTab !== '0'"
                    ttText="custactcalc_postcalc"
                    ttGoto="postcalc"
                    [ttGotoParms]="{ argtype: 'custact_no', argvalue: get.custact_no }"
                ></tt-button-goto>
                <tt-button-save
                    class="col-xs-12 col-md-8 sp-5"
                    [hidden]="!(selectedPostTab === 'TEXT' && selectedCustactCalcOrderTab === 'SUBTASKS')"
                    ttText="save"
                    (ttClick)="saveSubtasksTexts()"
                    [ttLoading]="saving"
                ></tt-button-save>
            </tt-card>
        </div>

        <div [hidden]="!(selectedPostTab === 'TEXT' && selectedCustactCalcOrderTab === 'SUBTASKS')" class="flex-column flex-1" style="overflow: auto">
            <div class="col-xs-12 sp-0 flex-1" style="overflow: auto">
                <tt-card *ngFor="let item of subtasksTexts" class="col-xs-12 col-md-6 p-5" [ttHeading]="item.heading" ttTranslateHeading="false">
                    <tt-textarea ttLabel="text_sales" [(ttModel)]="item.text_sales" (ttModelChange)="onSubtasksChanged()"></tt-textarea>
                    <tt-textarea ttLabel="text_production" [(ttModel)]="item.text_production" (ttModelChange)="onSubtasksChanged()"></tt-textarea>
                    <tt-input-number ttLabel="sortorderno" [(ttModel)]="item.sortorderno" ttDecimals="0" (ttModelChange)="onSubtasksChanged()"></tt-input-number>
                    <tt-textarea ttLabel="drawing_no" [(ttModel)]="item.drawing_no" (ttModelChange)="onSubtasksChanged()"></tt-textarea>
                </tt-card>
            </div>
        </div>

        <tt-card [hidden]="selectedCustactCalcOrderTab !== '0'" class="col-xs-12 col-md-6 p-5">
            <tt-input *ngIf="get.order_internal_no > '0'" ttLabel="order_name" [ttModel]="get.order_name" ttReadonly [ttButtons]="orderNameButtons"></tt-input>
            <tt-input ttLabel="cust_no" [ttModel]="get.cust_no" ttReadonly></tt-input>
            <tt-input ttLabel="cust_name" [ttModel]="get.cust_name" ttReadonly></tt-input>
            <tt-input *ngIf="get.orderline_keyno > '0'" ttLabel="orderline_keyno" [ttModel]="get.orderline_keyno" ttReadonly></tt-input>
            <tt-input *ngIf="get.po_keyno > '0'" ttLabel="po_keyno" [ttModel]="get.po_keyno" ttReadonly></tt-input>
        </tt-card>

        <tt-grid *ngIf="!!grid" [hidden]="!(selectedCustactCalcOrderTab === 'SUBTASKS' && selectedPostTab === 'POST')" class="col-xs-12 flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
    </div>
    <tt-card class="col-xs-12 col-md-6 p-5">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>
